module.exports = __webpack_public_path__ + "img/img_61.43013ff4.png";